import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkIsEligibleRequest = {};
var _bulkIsEligibleResponse = {};
var _feature = {
    createdAt: 'google.protobuf.Timestamp',
    updatedAt: 'google.protobuf.Timestamp',
};
var _getFeatureRequest = {};
var _getFeatureResponse = { features: '_feature' };
var _getFeaturesBulkRequest = {};
var _getFeaturesBulkResponse = { features: '_feature' };
var _isEligibleRequest = {};
var _isEligibleResponse = {};
var _listFeaturesRequest = {};
var _listFeaturesResponse = { features: '_feature' };
var _reportQuotaUsageRequest = {
    usageDateInUtc: 'google.protobuf.Timestamp',
};
var _reportQuotaUsageResponse = {};
function resolveComWixpressPremiumFeaturesmanagerApiV1FeaturesManagerUrl(opts) {
    var domainToMappings = {
        'www._base_domain_': [
            {
                srcPath: '/premium-features-manager-service',
                destPath: '',
            },
            {
                srcPath: '/_api/premium-features-manager',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/_api/premium-features-manager-service',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/premium-features-manager',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/premium-features-manager',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/premium-features-manager',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/premium-features-manager',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/premium-features-manager-service',
                destPath: '',
            },
            {
                srcPath: '/_api/premium-features-manager',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/premium-features-manager',
                destPath: '',
            },
            {
                srcPath: '/premium-features-manager-service',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/premium-features-manager-service',
                destPath: '',
            },
            {
                srcPath: '/_api/premium-features-manager',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/premium-features-manager',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/premium-features-manager-service',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/premium-features-manager-service',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/premium-features-manager-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Retrieves a list of feature instances, given the provided filtering and sorting.
 *
 *
 * Both instances that the customer is still eligible to use and those that they
 * have reached the usage quota for are returned.
 *
 * <blockquote class='warning'>
 *
 * __Important__:
 *
 * The List features endpoint places a heavy workload on the servers.
 * Avoid calling it unnecessarily. Instead, you should call
 * [Is Eligible](https://bo.wix.com/wix-docs/rest/premium/premium-features-manager/is-eligible)
 * whenever possible.
 *
 * </blockquote>
 *
 * If a feature is available free of charge to users, it has a feature ID of `DEFAULT`.
 */
export function listFeatures(payload) {
    var _a = serializer(_listFeaturesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listFeaturesResponse, { _feature: _feature }).fromJSON;
    function __listFeatures(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.features_manager.v1.feature',
            method: 'GET',
            methodFqn: 'com.wixpress.premium.featuresmanager.api.v1.FeaturesManager.ListFeatures',
            url: resolveComWixpressPremiumFeaturesmanagerApiV1FeaturesManagerUrl({
                protoPath: '/v1/features',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listFeatures.fromReq = fromReq;
    __listFeatures.__isAmbassador = true;
    return __listFeatures;
}
/**
 * Retrieves all instances of a specific feature that are associated with the customer.
 *
 *
 * Features may be included in multiple products simultaneously,
 * thus customers may have access to more than a single instance of a specific feature.
 *
 * Both instances that the customer is still eligible to use and those that they
 * have reached the usage quota for are returned.
 *
 * > __Note__: Call [Is Eligible](https://bo.wix.com/wix-docs/rest/premium/premium-features-manager/is-eligible)
 * > to check whether a user currently has access to the specified feature.
 *
 * If a feature is available free of charge to customers, it has a feature ID of `DEFAULT`.
 */
export function getFeature(payload) {
    var _a = serializer(_getFeatureRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getFeatureResponse, { _feature: _feature }).fromJSON;
    function __getFeature(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.features_manager.v1.feature',
            method: 'GET',
            methodFqn: 'com.wixpress.premium.featuresmanager.api.v1.FeaturesManager.GetFeature',
            url: resolveComWixpressPremiumFeaturesmanagerApiV1FeaturesManagerUrl({
                protoPath: '/v1/features/{uniqueName}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getFeature.fromReq = fromReq;
    __getFeature.__isAmbassador = true;
    return __getFeature;
}
/**
 * Retrieves instances for multiple features.
 *
 *
 * Features may be included in multiple products simultaneously,
 * thus customers may have access to more than a single instance of a specific feature.
 *
 * Both instances that the customer is still eligible to use and those that they
 * have reached the usage quota for are returned.
 *
 * Use this endpoint to retrieve information about the general settings of the
 * feature’s quota, but not when checking the currently remaining quota.
 *
 * > __Note__: Call [Is Eligible](https://bo.wix.com/wix-docs/rest/premium/premium-features-manager/is-eligible)
 * > to check whether a user currently has access to the specified feature.
 *
 * If a feature is available free of charge to users, it has a feature ID of `DEFAULT`.
 */
export function getFeaturesBulk(payload) {
    var _a = serializer(_getFeaturesBulkRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getFeaturesBulkResponse, {
        _feature: _feature,
    }).fromJSON;
    function __getFeaturesBulk(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.features_manager.v1.feature',
            method: 'GET',
            methodFqn: 'com.wixpress.premium.featuresmanager.api.v1.FeaturesManager.GetFeaturesBulk',
            url: resolveComWixpressPremiumFeaturesmanagerApiV1FeaturesManagerUrl({
                protoPath: '/v1/bulk-features',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getFeaturesBulk.fromReq = fromReq;
    __getFeaturesBulk.__isAmbassador = true;
    return __getFeaturesBulk;
}
/**
 * Checks whether the customer is currently allowed to use the feature.
 *
 *
 * You must specify how many times the customer intends to use the feature by
 * passing `eligibleToIncrementBy`.
 *
 * If a customer has access to multiple instances of the same feature, the
 * returned `isEligible` boolean is `true` when the request doesn't exceed the
 * combined remaining quota for all instances. In case the customer would
 * exceed the combined remaining quota, `isEligible` is returned as `false`.
 */
export function isEligible(payload) {
    var _a = serializer(_isEligibleRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_isEligibleResponse, {}).fromJSON;
    function __isEligible(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.features_manager.v1.feature',
            method: 'GET',
            methodFqn: 'com.wixpress.premium.featuresmanager.api.v1.FeaturesManager.IsEligible',
            url: resolveComWixpressPremiumFeaturesmanagerApiV1FeaturesManagerUrl({
                protoPath: '/v1/features/{uniqueName}/is-eligible',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __isEligible.fromReq = fromReq;
    __isEligible.__isAmbassador = true;
    return __isEligible;
}
/**
 * Checks whether the customer is currently allowed to use a list of features.
 *
 *
 * You must specify how many times the customer intends to use each feature by
 * passing `eligibleToIncrementBy`.
 *
 * If a customer has access to multiple instances of the same feature, the
 * returned `isEligible` boolean is `true` when the request doesn't exceed the
 * combined remaining quota for all instances. In case the customer would
 * exceed the combined remaining quota, `isEligible` is returned as `false`.
 */
export function bulkIsEligible(payload) {
    var _a = serializer(_bulkIsEligibleRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkIsEligibleResponse, {}).fromJSON;
    function __bulkIsEligible(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.features_manager.v1.feature',
            method: 'POST',
            methodFqn: 'com.wixpress.premium.featuresmanager.api.v1.FeaturesManager.BulkIsEligible',
            url: resolveComWixpressPremiumFeaturesmanagerApiV1FeaturesManagerUrl({
                protoPath: '/v1/features/is-eligible',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkIsEligible.fromReq = fromReq;
    __bulkIsEligible.__isAmbassador = true;
    return __bulkIsEligible;
}
/**
 * Logs that a user has used the feature instance.
 *
 *
 * You must specify how many times the feature instance has been used via the
 * `incrementBy` parameter.
 *
 * > __Note__: This endpoint doesn’t check whether a user is eligible to use
 * > the feature. To do so call
 * > [Is Eligible](https://bo.wix.com/wix-docs/rest/premium/premium-features-manager/is-eligible)
 * > before reporting the quota.
 *
 * If a customer has access to multiple instances of the same feature, the
 * usage isn't reported for an individual instance. Instead, it's logged in a
 * combined manner for all instances.
 *
 * Triggers an `updated`
 * [Feature Event](https://bo.wix.com/wix-docs/rest/premium/premium-features-manager/feature-event).
 */
export function reportQuotaUsage(payload) {
    var _a = serializer(_reportQuotaUsageRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_reportQuotaUsageResponse, {}).fromJSON;
    function __reportQuotaUsage(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.features_manager.v1.feature',
            method: 'GET',
            methodFqn: 'com.wixpress.premium.featuresmanager.api.v1.FeaturesManager.ReportQuotaUsage',
            url: resolveComWixpressPremiumFeaturesmanagerApiV1FeaturesManagerUrl({
                protoPath: '/v1/features/{uniqueName}/report-quota-usage',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __reportQuotaUsage.fromReq = fromReq;
    __reportQuotaUsage.__isAmbassador = true;
    return __reportQuotaUsage;
}
//# sourceMappingURL=http.impl.js.map